<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
// import { getBranches } from '@/utils/branch';
import { useToast } from 'vue-toastification';
import { permissionsMixin } from '@/mixins/userPermissions';
import QuotationChart from '@/components/analytic/quotation-chart';
import LeadStageChart from '@/components/analytic/lead-stage-chart';
import LeadSourceChart from '@/components/analytic/lead-source-chart';
import TopSellingItemChart from '@/components/analytic/top-selling-item-chart';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore';
import TeamAttendanceCalendar from '@/components/TeamAttendanceCalendar.vue';

export default {
  inject: ['setLoading'],
  mixins: [permissionsMixin],
  components: {
    LeadStageChart,
    QuotationChart,
    LeadSourceChart,
    TopSellingItemChart,
    TeamAttendanceCalendar
  },
  data() {
    return {
      branch: null,
      low_stock_count: 0,
      branch_id: '',
      // branches: [],
      quotation_by_status: [],
      today_birthday: [],
      upcoming_birthday: [],
      chartKey: 0,
      chartKeyUserRole: 0,
      chartKeyProposalStatus: 0,
      chartKeyQuotationStatus: 0,
      chartKeySourceStatus: 0,
      chartKeyTopSellingItemStatus: 0,
      errors: {},
      title: "Admin Dashboard",
      text: "Dashboard",
      text1: "Admin Dashboard",
      isCollapsed: false,
      toast: useToast(),
      total: {
        users: 0,
        leads: 0,
        customers: 0,
        active_leads: 0,
        converted_leads: 0,
        items: 0,
        proposals: 0,
        quotations: 0,
      },
      todays_reminder: 0,
      stage_wise_lead_distribution: [],
      lead_stage_chart_config: {
        type: 'doughnut',
        data: {
          labels: [],
          datasets: [{
            label: 'Lead Stage',
            data: [],
            backgroundColor: [],
            borderWidth: 5,
            borderRadius: 10,
            borderColor: '#fff',
            hoverBorderWidth: 0,
            cutout: '60%',
          }]
        },
        options: {
          rotation: -100,
          circumference: 200,
          layout: { padding: { top: -20, bottom: -20 } },
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } }
        }
      },

      source_wise_lead_distribution: [],
      top_selling_items: [],

      proposal_status_chart_config: {
        type: 'bar',
        stacked: true,
        data: {
          labels: [],
          datasets: [{
            label: 'Proposal Status',
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            borderColor: '#fff',
            borderRadius: 4,
            hoverBorderWidth: 0,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1,
              },
            },
          }
        },
      },

      quotation_status_chart_config: {
        type: 'line',
        data: {
          labels: [],
          datasets: [{
            label: 'Quotation Status',
            data: [],
            backgroundColor: [],
            borderWidth: 2,
            borderColor: [],
            fill: true,
            tension: 0.4,
            pointRadius: 5,
            pointHoverRadius: 7,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              // ticks: {
              //   stepSize: 1,
              // },
            },
          }
        },
      },

      user_roles: {
        roles: {
          chart: {
            height: 220,
            type: 'bar',
            padding: { top: 0, left: 0, right: 0, bottom: 0 },
            toolbar: { show: false },
          },
          colors: ['#66BB6A'],
          grid: {
            borderColor: '#66BB6A',
            strokeDashArray: 5,
            padding: { top: -20, left: 0, right: 0, bottom: 0 }
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              horizontal: false,
              columnWidth: '30%',
              endingShape: 'rounded'
            }
          },
          dataLabels: { enabled: false },
          xaxis: {
            categories: [],
            labels: {
              style: { colors: '#66BB6A', fontSize: '13px' }
            }
          },
        },
        series: [{
          data: [],
          name: 'Users'
        }]
      },
      total_sampling_requests: '',
      overdue_sampling_requests: '',
      pending_sampling_requests: '',
      showAllStages: false,
      failedImageIds: {},
      upcoming_holidays: [],
      on_leave_today: [],
      remote_employees: [],
      currentHolidayIndex: 0,
      holidayCarouselTimer: null,
      announcements: [],
      work_anniversary: [],
      new_joiners: [],
      activeHrTab: 'birthdays',
      hrUpdatesCollapsed: false,
      // ===== DASHBOARD TAB SWITCHER (UI only) =====
      // 'crm'  -> Leads/Quotation/Users-by-role stats + charts
      // 'hrms' -> Holidays / On Leave / Remote / HR Updates / Team Attendance
      activeDashboardTab: 'crm',
      showBirthdayPopper: false,
    };
  },

  computed: {
    hrTabs() {
      return [
        { key: 'birthdays', label: 'Birthdays', icon: 'ti-cake', count: this.today_birthday.length },
        { key: 'anniversaries', label: 'Work Anniversaries', icon: 'ti-award', count: this.work_anniversary.length },
        { key: 'new_joiners', label: 'New Joiners', icon: 'ti-user-plus', count: this.new_joiners.length },
        { key: 'announcements', label: 'Announcements', icon: 'ti-speakerphone', count: this.announcements.length },
      ];
    },


    branches() { return useLeadMetaStore().branches || [] },
    leadChartData() {
      return {
        total_leads: this.total.leads,
        active_leads: this.total.active_leads,
        stage_wise_lead_distribution: this.stage_wise_lead_distribution
      };
    },
    quotationReportData() {
      return {
        total_quotations: this.total.quotations,
        quotation_by_status: this.quotation_by_status
      };
    },

    // ===== UI-ONLY computed additions =====
    // These only reorder the SAME data already fetched from the API
    // (this.stage_wise_lead_distribution). No new API calls, no data mutation.

    // UI only — header greeting text
    greetingText() {
      const h = new Date().getHours();
      if (h < 12) return 'Good Morning';
      if (h < 17) return 'Good Afternoon';
      return 'Good Evening';
    },

    // Sort stages by count, descending — so highest-count stages show first
    sortedStages() {
      return [...this.stage_wise_lead_distribution].sort((a, b) => b.count - a.count);
    },

    // "Show all stages" button only needed when there are enough cards
    // to overflow the ~3-row collapsed view (roughly > 6 cards on the
    // smallest 2-per-row breakpoint). CSS handles the actual clipping
    // per breakpoint, this just decides whether the toggle is worth showing.
    hasHiddenStages() {
      return this.sortedStages.length > 6;
    },

    // Quick derived numbers for the hero KPI cards (pure display, same source data)
    conversionRate() {
      if (!this.total.leads) return 0;
      return Math.round((this.total.converted_leads / this.total.leads) * 100);
    },

    // ===== HRM SNAPSHOT WIDGET computed =====
    currentHoliday() {
      return this.upcoming_holidays[this.currentHolidayIndex] || null;
    },
    hasMultipleHolidays() {
      return this.upcoming_holidays.length > 1;
    },
    // on_leave_today can come either flat ({ full_name, user }) or nested
    // under an `employee` key ({ employee: { full_name, user } }) depending
    // on the backend query — normalize both shapes here so the template
    // never breaks or shows "undefined undefined".
    normalizedOnLeave() {
      return this.on_leave_today.map(p => p.employee || p);
    }
  },

  mounted() {
    this.allBranches();
    this.dashboardData();
    this.setPermissions(this.auth);
    this.loadLowStock();
  },

  beforeUnmount() {
    this.stopHolidayCarousel();
  },

  methods: {

    checkOwnBirthday() {
      const myUserId = this.auth?.id;
      if (!myUserId) return;

      const isMyBirthday = this.today_birthday.some(p => p.user_id === myUserId);

      if (!isMyBirthday) return;

      const todayKey = `bday_popper_${new Date().toISOString().slice(0, 10)}_${myUserId}`;
      if (localStorage.getItem(todayKey)) return;

      this.showBirthdayPopper = true;
      localStorage.setItem(todayKey, 'true');

      import('canvas-confetti').then(({ default: confetti }) => {
        confetti({ particleCount: 150, spread: 90, origin: { y: 0.6 } });
        setTimeout(() => {
          confetti({ particleCount: 100, spread: 120, origin: { y: 0.4 } });
        }, 300);
      });
    },

    dismissBirthdayPopper() {
      this.showBirthdayPopper = false;
    },

    setActiveHrTab(key) {
      this.activeHrTab = key;
    },
    toggleHrUpdates() {
      this.hrUpdatesCollapsed = !this.hrUpdatesCollapsed;
    },
    announcementBadgeClass(type) {
      const map = { urgent: 'hr-badge-urgent', normal: 'hr-badge-normal', info: 'hr-badge-info' };
      return map[type] || 'hr-badge-normal';
    },
    // ===== DASHBOARD TAB SWITCHER (UI only) =====
    setActiveDashboardTab(tab) {
      this.activeDashboardTab = tab;
    },
    handleImageError(person) {
      const id = person?.user_id || person?.id;
      this.failedImageIds[id] = true;
    },

    imageFailed(person) {
      const id = person?.user_id || person?.id;
      return !!this.failedImageIds[id];
    },

    getInitials(person) {
      const first = person?.first_name?.trim()?.charAt(0) || '';
      const last = person?.last_name?.trim()?.charAt(0) || '';
      const initials = (first + last).toUpperCase();
      return initials || (person?.full_name?.charAt(0)?.toUpperCase() || '?');
    },

    getAvatarColor(person) {
      const colors = ['#3a6df0', '#6a4cf5', '#e0576e', '#4c8c5a', '#f59e0b', '#0c5ddf', '#8a4cf0'];
      const name = person?.full_name || `${person?.first_name || ''}${person?.last_name || ''}`;
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    },

    formatBirthdayShortDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d)) return '';

      const today = new Date();
      today.setHours(0, 0, 0, 0);


      const thisYearBday = new Date(today.getFullYear(), d.getMonth(), d.getDate());
      const diffDays = Math.round((thisYearBday - today) / (1000 * 60 * 60 * 24));

      if (diffDays === 0) return 'Today';
      if (diffDays === 1) return 'Tomorrow';

      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'long' });
    },

    async loadLowStock() {
      try {
        const response = await axios.get('/inventory/stocks/low-stock');
        this.low_stock_count = response.data.data.total_low_stock_items || 0;
      } catch (error) {
        console.error('Low stock fetch failed:', error.message);
      }
    },

    // async allBranches() {
    //   this.branches = await getBranches();
    // },

    async allBranches() {
      await useLeadMetaStore().loadAll()
    },

    openStageLeads(stage) {
      this.$refs.chartModal.getLeads(
        '',                 // user_id
        '',                 // from_date
        '',                 // to_date
        stage.stage_id,     // lead_stage_id from stage object
        this.branch_id,     // branch_id from parent
        1                   // page
      );

      // show Bootstrap modal
      const modalEl = document.getElementById('lead_detail_modal');
      if (modalEl) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    },

    // ===== HRM SNAPSHOT WIDGET methods =====
    startHolidayCarousel() {
      this.stopHolidayCarousel();
      if (this.upcoming_holidays.length > 1) {
        this.holidayCarouselTimer = setInterval(() => {
          this.nextHoliday();
        }, 4000);
      }
    },
    stopHolidayCarousel() {
      if (this.holidayCarouselTimer) {
        clearInterval(this.holidayCarouselTimer);
        this.holidayCarouselTimer = null;
      }
    },
    nextHoliday() {
      if (!this.upcoming_holidays.length) return;
      this.currentHolidayIndex =
        (this.currentHolidayIndex + 1) % this.upcoming_holidays.length;
    },
    prevHoliday() {
      if (!this.upcoming_holidays.length) return;
      this.currentHolidayIndex =
        (this.currentHolidayIndex - 1 + this.upcoming_holidays.length) %
        this.upcoming_holidays.length;
    },
    goToHoliday(index) {
      this.currentHolidayIndex = index;
      // restart the auto-rotate timer so it doesn't jump right after a manual click
      this.startHolidayCarousel();
    },
    formatHolidayDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d)) return dateStr;
      return d.toLocaleDateString('en-IN', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    },
    formatHolidayDay(dateStr) {
      const d = new Date(dateStr);
      return isNaN(d) ? '--' : d.getDate().toString().padStart(2, '0');
    },
    formatHolidayMonth(dateStr) {
      const d = new Date(dateStr);
      return isNaN(d) ? '' : d.toLocaleDateString('en-IN', { month: 'short' });
    },
    formatHolidayWeekday(dateStr) {
      const d = new Date(dateStr);
      return isNaN(d) ? '' : d.toLocaleDateString('en-IN', { weekday: 'long' });
    },
    // Opens the "All Holidays" list modal — no page navigation.
    openHolidaysModal() {
      const modalEl = document.getElementById('holidays_list_modal');
      if (modalEl) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    },

    async dashboardData() {
      this.setLoading(true);
      try {
        this.branch_id = this.branch?.id || '';
        const params = {
          branch_id: this.branch_id
        };
        const query_string = new URLSearchParams(params).toString();
        const response = await axios.get(`/dashboard?${query_string}`);
        this.total.users = response.data.data.total_users;
        this.total.leads = response.data.data.total_leads;
        this.total.customers = response.data.data.total_customers;
        this.total.active_leads = response.data.data.active_leads;
        this.total.converted_leads = response.data.data.converted_leads;
        this.total.items = response.data.data.total_items;
        this.total.proposals = response.data.data.total_proposals;
        this.total.quotations = response.data.data.total_quotations;
        this.todays_reminder = response.data.data.todays_reminder;
        this.total_sampling_requests = response.data.data.total_sampling_requests;
        this.overdue_sampling_requests = response.data.data.overdue_sampling_requests;
        this.pending_sampling_requests = response.data.data.pending_sampling_requests;
        this.today_birthday = response.data.data.today_birthdays || [];
        this.upcoming_birthday = response.data.data.upcoming_birthdays || [];
        this.checkOwnBirthday();

        const distribution = response.data.data.stage_wise_lead_distribution || [];
        this.stage_wise_lead_distribution = distribution;

        this.lead_stage_chart_config = {
          type: 'doughnut',
          data: {
            labels: distribution.map(s => s.stage),
            datasets: [{
              label: "Lead Stages",
              data: distribution.map(s => Number(s.percentage) || 0),
              backgroundColor: distribution.map(s => s.color || '#999'),
              borderWidth: 5,
              borderRadius: 10,
              borderColor: '#fff',
              hoverBorderWidth: 0,
              cutout: '60%',
            }]
          },
          options: {
            rotation: -100,
            circumference: 200,
            layout: { padding: { top: -20, bottom: -20 } },
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: false } }
          }
        };
        //FORCE CHART RELOAD
        this.chartKey++;

        // ##########################################
        //            PROPOSAL CHART 
        // ##########################################

        const statusColors = {
          Draft: '#FFA726',
          Sent: '#29B6F6',
          Accepted: '#66BB6A',
          Rejected: '#EF5350'
        };

        const proposal_by_status = response.data.data.proposal_by_status;

        this.proposal_status_chart_config.data = {
          labels: ['Proposals'],  // single label on x-axis; bars stacked or grouped on this
          datasets: proposal_by_status.map(item => ({
            label: item.status,
            data: [item.count],    // each dataset has one value, for the single x-axis grouping
            backgroundColor: statusColors[item.status] || '#999999',
            borderWidth: 1,
            borderColor: '#fff',
            borderRadius: 4,
            hoverBorderWidth: 0,
          }))
        };

        this.chartKeyProposalStatus++;

        // ##########################################
        //            QUOTATION CHART 
        // ##########################################  

        const quotation_by_status = response.data.data.quotation_by_status;
        this.quotation_by_status = quotation_by_status;
        this.quotation_status_chart_config.data = {
          labels: quotation_by_status.map(item => item.status),  // ← x-axis pe statuses
          datasets: [{
            label: 'Quotation Amount',
            data: quotation_by_status.map(item => item.amount),  // ← amounts
            backgroundColor: 'rgba(41, 182, 246, 0.2)',          // ← light fill
            borderColor: '#29B6F6',                               // ← line color
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 5,
            pointBackgroundColor: '#29B6F6',
            pointHoverRadius: 7,
          }]
        };

        this.chartKeyQuotationStatus++;

        // ##########################################
        //            USER ROLES CHART 
        // ##########################################  

        const users_by_roles = response.data.data.users_by_roles;

        this.user_roles.roles.xaxis.categories = users_by_roles.map(item => item.role);
        this.user_roles.series[0].data = users_by_roles.map(item => item.count);

        this.chartKeyUserRole++;

        // ##########################################
        //            LEAD SOURCE CHART 
        // ########################################## 

        this.source_wise_lead_distribution = response.data.data.source_wise_lead_distribution;
        this.chartKeySourceStatus++;

        // ##########################################
        //          TOP SELLING ITEM CHART 
        // ##########################################  

        this.top_selling_items = response.data.data.top_selling_items;
        this.chartKeyTopSellingItemStatus++;

        // ##########################################
        //          HRM SNAPSHOT 
        // ##########################################
        this.upcoming_holidays = response.data.data.upcoming_holidays || [];
        this.on_leave_today = response.data.data.on_leave_today || [];
        this.remote_employees = response.data.data.remote_employees || [];
        this.currentHolidayIndex = 0;
        this.startHolidayCarousel();

        // ##########################################
        //          HR UPDATES 
        // ##########################################
        this.announcements = response.data.data.announcements || [];
        this.work_anniversary = response.data.data.work_anniversary || [];
        this.new_joiners = response.data.data.new_joiners || [];

      } catch (error) {
        console.error(error.message);
        this.toast.error('Failed to load dashboard data');
      } finally {
        this.setLoading(false);
      }
    },

  },
};
</script>


<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content dash-surface">

      <transition name="fade">
        <div v-if="showBirthdayPopper" class="birthday-banner" @click="dismissBirthdayPopper">
          <i class="ti ti-cake"></i>
          <span>Happy Birthday, {{ auth?.name?.split(' ')[0] }}! 🎉🎂</span>
          <button class="birthday-banner__close" @click.stop="dismissBirthdayPopper"><i class="ti ti-x"></i></button>
        </div>
      </transition>

      <hrm-punch-widget v-if="getPermission('Attendance', 'read') && auth?.type !== 'ADMIN'" />
      <!-- Breadcrumb -->
      <div class="d-md-none d-none align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="ms-2 head-icons custom-vueselect" v-if="auth?.type === 'ADMIN'">
            <vue-select :options="branches" label="name" v-model="branch" placeholder="All Branches"
              @update:modelValue="dashboardData" />
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="card d-none" style="border:none">
        <div class="card-body d-flex align-items-center justify-content-between flex-wrap pb-1 bg-white">
          <div class="d-flex align-items-center mb-3">
            <span class="avatar avatar-xl flex-shrink-0">
              <img :src="$profileImage(auth?.image, clientAdmin)" class="rounded-circle" alt="img" />
            </span>
            <div class="ms-3">
              <h3 class="mb-2">
                Welcome Back, {{ auth?.name }}
                <router-link to="/profile" class="edit-icon"><i class="ti ti-edit fs-14"></i></router-link>
              </h3>
              <p>Here’s what’s happening with your business today.</p>
            </div>
          </div>

          <!-- overdue card -->
          <div v-if="overdue_sampling_requests > 0 && auth?.type === 'ADMIN'" class="col-lg-3 col-12">
            <div class="card border-0 alert-card-overdue position-relative overflow-hidden"
              style="border-radius: 12px; border: 1px solid #f5c2c7 !important; background: #fff;">
              <div class="card-body p-3">

                <div class="d-flex align-items-center mb-3">
                  <!-- Icon + Blinking dot -->
                  <div class="alert-icon-wrapper position-relative me-3">
                    <div
                      style="width:42px; height:42px; border-radius:10px; background:#fee2e2; display:flex; align-items:center; justify-content:center;">
                      <i class="ti ti-alert-circle text-danger" style="font-size:22px;"></i>
                    </div>
                    <div class="blinking-dot-danger"
                      style="position:absolute; top:-3px; right:-3px; width:10px; height:10px; border-radius:50%; background:#dc3545; border:2px solid #fff5f5;">
                    </div>
                  </div>

                  <!-- Title + Subtitle -->
                  <div class="flex-grow-1">
                    <h6 class="mb-0 fw-bold text-danger" style="font-size:14px; letter-spacing:0.03em;">OVERDUE SAMPLING
                    </h6>
                    <p class="mb-0 text-muted" style="font-size:12px;">Action required now!</p>
                  </div>

                  <!-- Count Badge -->
                  <div style="background:#fee2e2; border-radius:8px; padding:4px 12px; text-align:center;">
                    <span class="fw-bold text-danger" style="font-size:26px; line-height:1;">{{
                      overdue_sampling_requests }}</span>
                    <p class="mb-0 text-danger" style="font-size:10px; opacity:0.7;">overdue</p>
                  </div>
                </div>

                <!-- Divider -->
                <hr style="border-color:#f5c2c7; margin: 0 0 12px 0;">

                <!-- Button -->
                <router-link :to="`/finance-accounts/samplings?status=overdue`"
                  class="btn btn-danger btn-sm fw-semibold w-100" style="font-size:13px; border-radius:8px;">
                  <i class="ti ti-clock-exclamation me-1"></i> Fix Now
                </router-link>

              </div>
            </div>
          </div>

          <!-- Low Stock Alert Card -->
          <div v-if="low_stock_count > 0" class="col-lg-3 col-12">
            <div class="card border-0 position-relative overflow-hidden"
              style="border-radius:12px; border:1px solid #fde68a !important; background:#fff;">
              <div class="card-body p-3">

                <div class="d-flex align-items-center mb-3">
                  <!-- Icon + Blinking dot -->
                  <div class="alert-icon-wrapper position-relative me-3">
                    <div
                      style="width:42px;height:42px;border-radius:10px;background:#fef9c3;display:flex;align-items:center;justify-content:center;">
                      <i class="ti ti-package-off text-warning" style="font-size:22px;"></i>
                    </div>
                    <div class="blinking-dot-warning"
                      style="position:absolute;top:-3px;right:-3px;width:10px;height:10px;border-radius:50%;background:#f59e0b;border:2px solid #fffbeb;">
                    </div>
                  </div>

                  <!-- Title + Subtitle -->
                  <div class="flex-grow-1">
                    <h6 class="mb-0 fw-bold text-warning" style="font-size:14px;letter-spacing:0.03em;">LOW STOCK</h6>
                    <p class="mb-0 text-muted" style="font-size:12px;">Restock required!</p>
                  </div>

                  <!-- Count Badge -->
                  <div style="background:#fef9c3;border-radius:8px;padding:4px 12px;text-align:center;">
                    <span class="fw-bold text-warning" style="font-size:26px;line-height:1;">{{ low_stock_count
                      }}</span>
                    <p class="mb-0 text-warning" style="font-size:10px;opacity:0.7;">items</p>
                  </div>
                </div>

                <!-- Divider -->
                <hr style="border-color:#fde68a;margin:0 0 12px 0;">

                <!-- Button -->
                <router-link to="/inventory/low-stock" class="btn btn-warning btn-sm fw-semibold w-100 text-white"
                  style="font-size:13px;border-radius:8px;">
                  <i class="ti ti-eye me-1"></i>View Low Stock
                </router-link>

              </div>
            </div>
          </div>

          <div class="d-flex align-items-center flex-wrap mb-1" v-if="todays_reminder > 0">
            <div class="card shadow-sm reminder-card">
              <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#all_reminder"
                @click="$refs.reminderModal.all();">
                <div class="card-body p-3">
                  <div class="row g-0 align-items-center">
                    <div class="col-auto">
                      <div class="reminder-indicator me-3">
                        <div class="blinking-dot"></div>
                        <i class="fas fa-bell text-muted reminder-icon"></i>
                      </div>
                    </div>
                    <div class="col">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 class="card-title reminder-title mb-0 fw-semibold me-2">Today's Reminders</h6>
                          <small class="text-muted">{{ $formatDate($currentDate()) }}</small>
                        </div>
                        <div class="text-end align-self-start">
                          <h4 class="text-primary mb-0 fw-bold lh-1">{{ todays_reminder }}</h4>
                          <div class="reminder-spacer"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>

          </div>

          <div class="d-flex align-items-center flex-wrap mb-1" v-else>
            <a href="javascript:void(0);" class="btn btn-secondary btn-md me-2 mb-2" data-bs-toggle="modal"
              data-bs-target="#lead_modal" @click="$refs.leadModal.add();" v-if="getPermission('Lead', 'create')"><i
                class="ti ti-user-check me-1"></i>Add Lead</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-md mb-2" data-bs-toggle="modal"
              data-bs-target="#quotation_modal" @click="$refs.quotationModal.add();"
              v-if="getPermission('Quotation', 'create')"><i class="ti ti-file-invoice me-1"></i>Add Quotation</a>
          </div>

        </div>
      </div>
      <!-- /Welcome Wrap -->

      <!-- ============================================================
           DASHBOARD HEADER + TAB SWITCHER (UI only — no logic/data change)
           Header is always visible. Tabs only shown if the user has any
           HRM visibility; otherwise the HRMS tab is irrelevant to them
           and CRM view is default anyway.
           ============================================================ -->
      <div class="dash-header">
        <div>
          <h3 class="dash-header__title">
            {{ greetingText }}, {{ auth?.name?.split(' ')[0] }} <span class="dash-header__wave">👋</span>
          </h3>
          <p class="dash-header__sub">Here's what's happening with your business today.</p>
        </div>
        <div class="dash-header__date">
          <i class="ti ti-calendar"></i>
          <span>{{ $formatDate($currentDate()) }}</span>
        </div>
      </div>

      <div class="dashboard-tabs mb-3" v-if="getPermission('Attendance', 'read')">
        <button type="button" class="dashboard-tab" :class="{ active: activeDashboardTab === 'crm' }"
          @click="setActiveDashboardTab('crm')">
          CRM Dashboard
        </button>
        <button type="button" class="dashboard-tab" :class="{ active: activeDashboardTab === 'hrms' }"
          @click="setActiveDashboardTab('hrms')">
          HRMS Dashboard
        </button>
      </div>
      <!-- /Dashboard Header + Tab Switcher -->

      <!-- ============================================================
           HRMS DASHBOARD TAB
           (HRM Snapshot + HR Updates + Team Attendance Calendar)
           ============================================================ -->
      <template v-if="getPermission('Attendance', 'read') && activeDashboardTab === 'hrms'">

        <!-- ============================================================
           HRM SNAPSHOT WIDGET 
           ============================================================ -->
        <div class="row g-3 mb-4">

          <!-- Holidays carousel -->
          <div class="col-md-4 col-12">
            <div class="hrm-card holiday-carousel-card">
              <div class="holiday-card__header">
                <span class="holiday-card__title"><i class="ti ti-calendar-star me-1"></i>Holidays</span>
                <a href="javascript:void(0);" class="holiday-card__viewall" @click="openHolidaysModal">View All</a>
              </div>

              <div v-if="upcoming_holidays.length" class="holiday-slide" :key="currentHolidayIndex">
                <h4 class="holiday-slide__name">{{ currentHoliday?.name }}</h4>
                <p class="holiday-slide__date">{{ formatHolidayDate(currentHoliday?.date) }}</p>
              </div>
              <div v-else class="holiday-slide holiday-slide--empty">
                <p class="mb-0">No upcoming holidays</p>
              </div>

              <div class="holiday-card__dots" v-if="hasMultipleHolidays">
                <span v-for="(h, idx) in upcoming_holidays" :key="idx" class="holiday-dot"
                  :class="{ active: idx === currentHolidayIndex }" @click="goToHoliday(idx)"></span>
              </div>

              <button v-if="hasMultipleHolidays" type="button" class="holiday-card__nav holiday-card__nav--prev"
                @click="prevHoliday(); startHolidayCarousel();">
                <i class="ti ti-chevron-left"></i>
              </button>
              <button v-if="hasMultipleHolidays" type="button" class="holiday-card__nav holiday-card__nav--next"
                @click="nextHoliday(); startHolidayCarousel();">
                <i class="ti ti-chevron-right"></i>
              </button>
            </div>
          </div>

          <!-- On Leave Today -->
          <div class="col-md-4 col-12">
            <div class="hrm-card">
              <div class="hrm-card__header">
                <span class="hrm-card__title">On Leave Today</span>
              </div>

              <div v-if="normalizedOnLeave.length" class="hrm-people-list">
                <div class="hrm-people-list__item" v-for="(person, idx) in normalizedOnLeave" :key="idx">
                  <img v-if="person.user?.image && !imageFailed(person)"
                    :src="$profileImage(person.user?.image, person)" class="hrm-avatar" alt="avatar"
                    @error="handleImageError(person)" />
                  <div v-else class="hrm-avatar hrm-avatar--initials" :style="{ background: getAvatarColor(person) }">{{
                    getInitials(person) }}</div>
                  <div class="hrm-people-list__info">
                    <span class="hrm-people-list__name">{{ person.full_name || `${person.first_name}
                      ${person.last_name}` }}</span>
                    <span class="hrm-people-list__meta" v-if="person.leave_type">{{ person.leave_type }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="hrm-empty-state">
                <i class="ti ti-mood-smile hrm-empty-state__icon"></i>
                <p class="mb-0">Everyone is working today!</p>
                <span class="hrm-empty-state__sub">No one is on leave today.</span>
              </div>
            </div>
          </div>

          <!-- Working Remotely -->
          <div class="col-md-4 col-12">
            <div class="hrm-card">
              <div class="hrm-card__header">
                <span class="hrm-card__title">Working Remotely</span>
              </div>

              <div v-if="remote_employees.length" class="hrm-avatar-stack-wrap">
                <div class="hrm-avatar-stack">
                  <div class="hrm-avatar-stack__item" v-for="(person, idx) in remote_employees" :key="idx"
                    :title="person.full_name">
                    <img v-if="person.user?.image && !imageFailed(person)"
                      :src="$profileImage(person.user?.image, person)" class="hrm-avatar hrm-avatar--stacked"
                      alt="avatar" @error="handleImageError(person)" />
                    <div v-else class="hrm-avatar hrm-avatar--stacked hrm-avatar--initials"
                      :style="{ background: getAvatarColor(person) }">{{ getInitials(person) }}</div>
                    <span class="hrm-avatar-stack__badge"><i class="ti ti-home"></i></span>
                  </div>
                </div>
                <div class="hrm-avatar-stack__names">
                  <span v-for="(person, idx) in remote_employees" :key="idx">
                    {{ person.full_name }}<span v-if="idx < remote_employees.length - 1">, </span>
                  </span>
                </div>
              </div>
              <div v-else class="hrm-empty-state">
                <i class="ti ti-building hrm-empty-state__icon"></i>
                <p class="mb-0">No one is working remotely today.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- /HRM Snapshot Widget -->

        <!-- ============================================================
             HR UPDATES WIDGET 
             ============================================================ -->
        <div class="row g-3 mb-4">
          <div class="col-12">
            <div class="hrm-card hr-updates-card">
              <div class="hr-updates-tabs">
                <button v-for="tab in hrTabs" :key="tab.key" type="button" class="hr-updates-tab"
                  :class="{ active: activeHrTab === tab.key }" @click="setActiveHrTab(tab.key)">
                  <i :class="`ti ${tab.icon}`"></i>
                  <span>{{ tab.count }} {{ tab.label }}</span>
                </button>
                <button type="button" class="hr-updates-collapse-btn" @click="toggleHrUpdates">
                  <i :class="hrUpdatesCollapsed ? 'ti ti-chevron-down' : 'ti ti-chevron-up'"></i>
                </button>
              </div>

              <div v-if="!hrUpdatesCollapsed" class="hr-updates-body">

                <!-- Birthdays tab -->
                <template v-if="activeHrTab === 'birthdays'">
                  <div v-if="today_birthday.length" class="birthday-section">
                    <h6 class="birthday-section__title">Birthdays today</h6>
                    <div class="birthday-today-list">
                      <div class="birthday-today-list__item" v-for="(person, idx) in today_birthday" :key="'tb-' + idx">
                        <img v-if="person.user?.image && !imageFailed(person)"
                          :src="$profileImage(person.user?.image, person)" class="hrm-avatar" alt="avatar"
                          @error="handleImageError(person)" />
                        <div v-else class="hrm-avatar hrm-avatar--initials"
                          :style="{ background: getAvatarColor(person) }">{{ getInitials(person) }}</div>
                        <span class="birthday-today-list__name">{{ person.full_name || `${person.first_name}
                          ${person.last_name}` }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="upcoming_birthday.length" class="birthday-section">
                    <h6 class="birthday-section__title">Upcoming Birthdays</h6>
                    <div class="birthday-upcoming-list">
                      <div class="birthday-upcoming-list__item" v-for="(person, idx) in upcoming_birthday"
                        :key="'ub-' + idx">
                        <img v-if="person.user?.image && !imageFailed(person)"
                          :src="$profileImage(person.user?.image, person)" class="hrm-avatar hrm-avatar--upcoming"
                          alt="avatar" @error="handleImageError(person)" />
                        <div v-else class="hrm-avatar hrm-avatar--upcoming hrm-avatar--initials"
                          :style="{ background: getAvatarColor(person) }">{{ getInitials(person) }}</div>
                        <span class="birthday-upcoming-list__name">{{ person.full_name || `${person.first_name}
                          ${person.last_name}` }}</span>
                        <span class="birthday-upcoming-list__date">{{ formatBirthdayShortDate(person.date_of_birth ||
                          person.date || person.dob || person.birth_date) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!today_birthday.length && !upcoming_birthday.length" class="hrm-empty-state">
                    <i class="ti ti-cake hrm-empty-state__icon"></i>
                    <p class="mb-0">No birthdays to show.</p>
                  </div>
                </template>

                <!-- Work Anniversaries tab -->
                <template v-else-if="activeHrTab === 'anniversaries'">
                  <div v-if="work_anniversary.length" class="hrm-people-list hr-updates-list">
                    <div class="hrm-people-list__item" v-for="(person, idx) in work_anniversary" :key="'wa-' + idx">
                      <img v-if="person.user?.image" :src="$profileImage(person.user?.image, person)" class="hrm-avatar"
                        alt="avatar" />
                      <div v-else class="hrm-avatar hrm-avatar--initials"
                        :style="{ background: getAvatarColor(person) }">{{ getInitials(person) }}</div>
                      <div class="hrm-people-list__info">
                        <span class="hrm-people-list__name">{{ person.full_name || `${person.first_name}
                          ${person.last_name}` }}</span>
                        <span class="hrm-people-list__meta">Work anniversary today</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="hrm-empty-state">
                    <i class="ti ti-award hrm-empty-state__icon"></i>
                    <p class="mb-0">No work anniversaries today.</p>
                  </div>
                </template>

                <!-- New Joiners tab -->
                <template v-else-if="activeHrTab === 'new_joiners'">
                  <div v-if="new_joiners.length" class="hrm-people-list hr-updates-list">
                    <div class="hrm-people-list__item" v-for="(person, idx) in new_joiners" :key="'nj-' + idx">
                      <img v-if="person.user?.image" :src="$profileImage(person.user?.image, person)" class="hrm-avatar"
                        alt="avatar" />
                      <div v-else class="hrm-avatar hrm-avatar--initials"
                        :style="{ background: getAvatarColor(person) }">{{ getInitials(person) }}</div>
                      <div class="hrm-people-list__info">
                        <span class="hrm-people-list__name">{{ person.full_name || `${person.first_name}
                          ${person.last_name}` }}</span>
                        <span class="hrm-people-list__meta">New joiner</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="hrm-empty-state">
                    <i class="ti ti-user-plus hrm-empty-state__icon"></i>
                    <p class="mb-0">No new joiners to show.</p>
                  </div>
                </template>

                <!-- Announcements tab -->
                <template v-else-if="activeHrTab === 'announcements'">
                  <div v-if="announcements.length" class="hr-announcement-list">
                    <div class="hr-announcement-item" v-for="ann in announcements" :key="ann.id">
                      <div class="hr-announcement-item__top">
                        <span class="hr-announcement-item__title">{{ ann.title }}</span>
                        <span class="hr-announcement-item__badge" :class="announcementBadgeClass(ann.type)">{{ ann.type
                          }}</span>
                      </div>
                      <p class="hr-announcement-item__content">{{ ann.content }}</p>
                    </div>
                  </div>
                  <div v-else class="hrm-empty-state">
                    <i class="ti ti-speakerphone hrm-empty-state__icon"></i>
                    <p class="mb-0">No announcements right now.</p>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
        <!-- Team Attendance Calendar -->
        <div class="row g-3 pb-4">
          <div class="col-12">
            <h6 class="pipeline-heading mb-2">Team Attendance</h6>
            <TeamAttendanceCalendar />
          </div>
        </div>
        <!-- /Team Attendance Calendar -->

      </template>
      <!-- /HRMS DASHBOARD TAB -->

      <!-- ============================================================
           CRM DASHBOARD TAB — UI REDESIGNED (data/logic unchanged)
           Renders when the CRM tab is active, OR when the user has no
           Attendance permission at all (tab switcher itself is hidden
           for them, so CRM is effectively the only view).
           ============================================================ -->
      <template v-if="!getPermission('Attendance', 'read') || activeDashboardTab === 'crm'">
        <template v-if="getPermission('Lead', 'read')">

          <!-- ========== KPI CARDS ========== -->
          <div class="row g-3 mb-3">

            <!-- Total Leads -->
            <div class="col-12 col-md-6">
              <router-link :to="`/crm/leads-list?branch_id=${branch_id}`" class="kpi-wide text-decoration-none">
                <span class="kpi-wide__icon kpi-wide__icon--blue"><i class="ti ti-users-group"></i></span>
                <div class="kpi-wide__body">
                  <p class="kpi-wide__label">Total Leads</p>
                  <h3 class="kpi-wide__value">{{ $numFormat(total.leads) }}</h3>
                  <span class="kpi-wide__meta">{{ $numFormat(total.active_leads) }} active</span>
                </div>
                <svg class="kpi-wide__spark" viewBox="0 0 200 60" preserveAspectRatio="none" aria-hidden="true">
                  <defs>
                    <linearGradient id="sparkBlue" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stop-color="#3b82f6" stop-opacity="0.22" />
                      <stop offset="100%" stop-color="#3b82f6" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                  <path d="M0 48 C20 44 30 40 45 42 S70 36 85 34 S115 40 130 30 S165 18 200 8 L200 60 L0 60 Z"
                    fill="url(#sparkBlue)" />
                  <path d="M0 48 C20 44 30 40 45 42 S70 36 85 34 S115 40 130 30 S165 18 200 8" fill="none"
                    stroke="#93b8f8" stroke-width="1.5" vector-effect="non-scaling-stroke" />
                </svg>
                <span class="kpi-wide__arrow"><i class="ti ti-chevron-right"></i></span>
              </router-link>
            </div>

            <!-- Converted Leads -->
            <div class="col-12 col-md-6">
              <router-link :to="{ name: 'leads-list', query: { conversion: true, branch_id: branch_id } }"
                class="kpi-wide text-decoration-none">
                <span class="kpi-wide__icon kpi-wide__icon--green"><i class="ti ti-filter"></i></span>
                <div class="kpi-wide__body">
                  <p class="kpi-wide__label">Converted Leads</p>
                  <h3 class="kpi-wide__value">{{ $numFormat(total.converted_leads) }}</h3>
                  <span class="kpi-wide__meta">
                    <span class="kpi-wide__badge">{{ conversionRate }}%</span> conversion rate
                  </span>
                </div>
                <svg class="kpi-wide__spark" viewBox="0 0 200 60" preserveAspectRatio="none" aria-hidden="true">
                  <defs>
                    <linearGradient id="sparkGreen" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stop-color="#22c55e" stop-opacity="0.22" />
                      <stop offset="100%" stop-color="#22c55e" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M0 40 C15 30 25 22 40 28 S60 42 80 30 S105 12 125 20 S160 34 180 22 S195 14 200 10 L200 60 L0 60 Z"
                    fill="url(#sparkGreen)" />
                  <path d="M0 40 C15 30 25 22 40 28 S60 42 80 30 S105 12 125 20 S160 34 180 22 S195 14 200 10"
                    fill="none" stroke="#86e0a4" stroke-width="1.5" vector-effect="non-scaling-stroke" />
                </svg>
                <span class="kpi-wide__arrow"><i class="ti ti-chevron-right"></i></span>
              </router-link>
            </div>

            <!-- Overdue sampling (same condition as before) -->
            <div class="col-12 col-md-6" v-if="overdue_sampling_requests > 0 && auth?.type === 'ADMIN'">
              <router-link :to="`/finance-accounts/samplings?status=overdue`" class="kpi-wide text-decoration-none">
                <span class="kpi-wide__icon kpi-wide__icon--red"><i class="ti ti-clock-exclamation"></i></span>
                <div class="kpi-wide__body">
                  <p class="kpi-wide__label">Needs Action</p>
                  <h3 class="kpi-wide__value">{{ overdue_sampling_requests }}</h3>
                  <span class="kpi-wide__meta">Overdue sampling</span>
                </div>
                <span class="kpi-wide__arrow"><i class="ti ti-chevron-right"></i></span>
              </router-link>
            </div>

            <!-- Reminders (same condition as before) -->
            <div class="col-12 col-md-6" v-if="todays_reminder > 0">
              <div class="kpi-wide">
                <span class="kpi-wide__icon kpi-wide__icon--sky"><i class="ti ti-bell"></i></span>
                <div class="kpi-wide__body">
                  <p class="kpi-wide__label">Reminders Today</p>
                  <h3 class="kpi-wide__value">{{ todays_reminder }}</h3>
                  <span class="kpi-wide__meta">Needs follow up</span>
                </div>
              </div>
            </div>
          </div>

          <!-- ========== LEAD PIPELINE ========== -->
          <div class="dash-card mb-3">
            <div class="dash-card__head">
              <span class="dash-card__icon"><i class="ti ti-chart-bar"></i></span>
              <h6 class="dash-card__title">Lead Pipeline</h6>
              <button type="button" class="show-more-btn ms-auto" v-if="hasHiddenStages"
                @click="showAllStages = !showAllStages">
                <i :class="showAllStages ? 'ti ti-chevron-up' : 'ti ti-chevron-down'" class="me-1"></i>
                {{ showAllStages ? 'Show less' : 'Show all stages' }}
              </button>
            </div>

            <!-- CSS max-height clips this to ~3 rows when collapsed. All stages
                 (including zero-count) always render; only visible height changes. -->
            <div class="row g-2 g-md-3 stage-cards-wrapper" :class="{ expanded: showAllStages }">
              <div class="col-6 col-sm-4 col-lg-3 col-xl-2 d-flex" v-for="(row, index) in sortedStages" :key="index">
                <router-link :to="{ name: 'leads-list', query: { lead_stage_id: row.stage_id, branch_id: branch_id } }"
                  class="stage-card flex-fill text-decoration-none" :class="{ 'stage-card--zero': row.count === 0 }"
                  :style="{ '--stage-color': row.color || '#6c757d' }">
                  <span class="stage-card__icon"><i class="ti ti-user-shield" aria-hidden="true"></i></span>
                  <div class="stage-card__text">
                    <span class="stage-card__label" :title="`${row.stage} Leads`">{{ row.stage }}</span>
                    <h3 class="stage-card__value">{{ $numFormat(row.count) }}</h3>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- ========== LEAD STAGE + QUOTATION ========== -->
          <div class="row g-3 align-items-stretch mb-3">
            <div class="col-lg-6 col-12">
              <div class="dash-card h-100">
                <div class="dash-card__head dash-card__head--divided">
                  <span class="dash-card__icon"><i class="ti ti-chart-bar"></i></span>
                  <div>
                    <h6 class="dash-card__title">Lead Stage Distribution</h6>
                    <p class="dash-card__sub">All active lead stages</p>
                  </div>
                </div>
                <LeadStageChart :chart-data="leadChartData" :chart-config="lead_stage_chart_config"
                  :chart-key="chartKey" center-label="Total Leads" @open-stage-leads="openStageLeads" />
              </div>
            </div>

            <div class="col-lg-6 col-12">
              <div class="dash-card h-100">
                <div class="dash-card__head dash-card__head--divided">
                  <span class="dash-card__icon"><i class="ti ti-file-invoice"></i></span>
                  <div>
                    <h6 class="dash-card__title">Quotation Status Overview</h6>
                    <p class="dash-card__sub">Draft, Sent, Accepted &amp; Rejected</p>
                  </div>
                </div>
                <QuotationChart :chart-data="quotationReportData" :chart-config="quotation_status_chart_config"
                  :chart-key="chartKeyQuotationStatus" />
              </div>
            </div>
          </div>

          <!-- ========== USERS BY ROLES (full width) ========== -->
          <div class="row g-3 mb-3" v-if="getPermission('User', 'read')">
            <div class="col-12">
              <div class="dash-card">
                <div class="dash-card__head dash-card__head--divided">
                  <span class="dash-card__icon"><i class="ti ti-users"></i></span>
                  <div>
                    <h6 class="dash-card__title">Users By Roles</h6>
                    <p class="dash-card__sub">Role-wise user distribution</p>
                  </div>
                </div>
                <apexchart :key="chartKeyUserRole" type="bar" height="260" :options="user_roles.roles"
                  :series="user_roles.series" />
              </div>
            </div>
          </div>

          <!-- ========== LEAD SOURCE + TOP SELLING ========== -->
          <div class="row g-3 mb-3">
            <div class="col-xl-5 col-lg-6 col-12">
              <LeadSourceChart :chart-data="source_wise_lead_distribution" :title="'Lead Source Distribution'" />
            </div>
            <div class="col-xl-7 col-lg-6 col-12">
              <TopSellingItemChart :chart-data="top_selling_items" :title="'Top 10 Selling Items'" />
            </div>
          </div>

        </template>
      </template>
      <!-- /CRM DASHBOARD TAB -->

    </div>

    <app-footer></app-footer>

  </div>

  <leads-modal ref="leadModal"></leads-modal>
  <chart-modal ref="chartModal"></chart-modal>
  <reminder-modal ref="reminderModal"></reminder-modal>
  <quotation-modal ref="quotationModal"></quotation-modal>

  <!-- ============================================================
       HOLIDAYS LIST MODAL — opened from the "View All" link on the
       Holidays card. Shows upcoming_holidays (same data already
       loaded from the /dashboard API — no extra call, no navigation).
       ============================================================ -->
  <div class="modal fade" id="holidays_list_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" style="border-radius:14px; overflow:hidden;">
        <div class="modal-header border-0 pb-0">
          <h5 class="modal-title fw-bold" style="font-size:16px;">Upcoming Holidays</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pt-2 pb-4">
          <div v-if="upcoming_holidays.length" class="holidays-modal-list">
            <div class="holidays-modal-list__item" v-for="(h, idx) in upcoming_holidays" :key="idx">
              <div class="holidays-modal-list__date-badge">
                <span class="holidays-modal-list__day">{{ formatHolidayDay(h.date) }}</span>
                <span class="holidays-modal-list__month">{{ formatHolidayMonth(h.date) }}</span>
              </div>
              <div class="holidays-modal-list__info">
                <span class="holidays-modal-list__name">{{ h.name }}</span>
                <span class="holidays-modal-list__weekday">{{ formatHolidayWeekday(h.date) }}</span>
              </div>
            </div>
          </div>
          <div v-else class="text-center text-muted py-4">
            No upcoming holidays
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.reminder-card {
  min-height: 60px;
  max-height: 75px;
  width: 100%;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.reminder-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
}

.reminder-indicator {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
}

.reminder-icon {
  font-size: 1.5rem !important;
  opacity: 0.7;
}

.blinking-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  background-color: #dc3545;
  border-radius: 50%;
  border: 2px solid white;
  animation: blink-animation 1.5s ease-in-out infinite;
  z-index: 10;
}

@keyframes blink-animation {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.2;
    transform: scale(0.7);
  }
}

.reminder-title {
  font-size: 0.95rem;
  color: #495057;
  line-height: 1.2;
}

.count-container {
  min-width: 60px;
  position: relative;
}

.text-primary {
  color: #0d6efd !important;
  font-size: 1.8rem;
  line-height: 1 !important;
}

.reminder-spacer {
  height: 16px;
  width: 100%;
}

.text-muted {
  font-size: 0.75rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .reminder-card {
    min-height: 65px;
  }

  .text-primary {
    font-size: 1.5rem;
  }

  .reminder-icon {
    font-size: 1.3rem;
  }

  .count-container {
    min-width: 50px;
  }
}
</style>

<style scoped>
/* ============================================================
   HEADER
   ============================================================ */
.dash-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.dash-header__title {
  font-size: 24px;
  font-weight: 800;
  color: #111936;
  margin: 0 0 2px;
}

.dash-header__sub {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

.dash-header__date {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  box-shadow: 0 2px 10px rgba(30, 64, 175, 0.06);
}

.dash-header__date i {
  font-size: 16px;
  color: #374151;
}

/* ============================================================
   KPI WIDE CARDS
   ============================================================ */
.kpi-wide {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 98px;
  padding: 18px 20px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(30, 64, 175, 0.05);
  overflow: hidden;
  color: inherit;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

a.kpi-wide:hover {
  box-shadow: 0 6px 18px rgba(30, 64, 175, 0.1);
  transform: translateY(-2px);
}

.kpi-wide__icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.kpi-wide__icon--blue {
  background: #e2edff;
  color: #2563eb;
}

.kpi-wide__icon--green {
  background: #dcf5e3;
  color: #16a34a;
}

.kpi-wide__icon--red {
  background: #fee2e2;
  color: #dc2626;
}

.kpi-wide__icon--sky {
  background: #e0f2fe;
  color: #0284c7;
}

.kpi-wide__body {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.kpi-wide__label {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 2px;
}

.kpi-wide__value {
  font-size: 28px;
  font-weight: 800;
  color: #111936;
  line-height: 1.1;
  margin: 0 0 4px;
}

.kpi-wide__meta {
  font-size: 11.5px;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.kpi-wide__badge {
  background: #dcfce7;
  color: #15803d;
  font-weight: 700;
  font-size: 11px;
  padding: 1px 8px;
  border-radius: 6px;
}

.kpi-wide__spark {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 50%;
  height: 75%;
  pointer-events: none;
}

.kpi-wide__arrow {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: #e8f0ff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  z-index: 2;
}

/* ============================================================
   GENERIC WHITE CARD (pipeline + chart wrappers)
   ============================================================ */
.dash-card {
  background: #fff;
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: 0 2px 10px rgba(30, 64, 175, 0.05);
}

.dash-card__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.dash-card__head--divided {
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f1f1;
}

.dash-card__icon {
  display: inline-flex;
  font-size: 20px;
  color: #2563eb;
}

.dash-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #111936;
  margin: 0;
}

.dash-card__sub {
  font-size: 12px;
  color: #8a8d99;
  margin: 0;
}

.pipeline-heading {
  font-size: 14px;
  font-weight: 600;
  color: #23253a;
  margin: 0;
}

.show-more-btn {
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 12px;
  border: 1px solid #e2e6f0;
  background: #fff;
  color: #4b5563;
  cursor: pointer;
}

/* ============================================================
   STAGE CARDS (pastel, icon-left)
   ============================================================ */
.stage-cards-wrapper {
  overflow: hidden;
  max-height: calc(3 * 70px + 2 * 8px);
  transition: max-height 0.35s ease;
}

.stage-cards-wrapper.expanded {
  max-height: 3000px;
}

.stage-card {
  --stage-color: #6c757d;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 70px;
  padding: 10px 12px;
  width: 100%;
  min-width: 0;
  border-radius: 12px;
  background: color-mix(in srgb, var(--stage-color) 9%, #ffffff);
  border: 1px solid color-mix(in srgb, var(--stage-color) 20%, #ffffff);
  transition: box-shadow 0.2s ease;
}

.stage-card:hover {
  box-shadow: 0 4px 12px rgba(20, 20, 40, 0.08);
}

.stage-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(20, 20, 40, 0.06);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stage-card__icon i {
  font-size: 20px;
  color: var(--stage-color);
}

.stage-card__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stage-card__label {
  font-size: 11px;
  color: #4b4f5e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stage-card__value {
  font-size: 17px;
  font-weight: 700;
  color: #111936;
  margin: 0;
  line-height: 1.2;
}

.stage-card--zero {
  opacity: 0.8;
}

.stage-card--zero:hover {
  opacity: 1;
}

@media (min-width: 768px) {
  .stage-cards-wrapper:not(.expanded) {
    max-height: calc(3 * 70px + 2 * 16px);
  }
}

@media (max-width: 767px) {
  .dash-header__title {
    font-size: 20px;
  }

  .kpi-wide__spark {
    width: 40%;
  }
}

@supports not (background: color-mix(in srgb, red 5%, white)) {
  .stage-card {
    background: #fafafa;
  }
}
</style>

<style scoped>
/* ============================================================
   HRM SNAPSHOT WIDGET — Keka-style cards
   (Holidays carousel / On Leave Today / Working Remotely)
   ============================================================ */
.hrm-card {
  position: relative;
  background: #ffffff;
  border: 1px solid #eef0f5;
  border-radius: 14px;
  padding: 16px 18px;
  height: 100%;
  min-height: 190px;
  display: flex;
  flex-direction: column;
}

.hrm-card__header {
  margin-bottom: 12px;
}

.hrm-card__title {
  font-size: 13px;
  font-weight: 700;
  color: #23253a;
}

/* ---- Holidays carousel card ---- */
.holiday-carousel-card {
  background: linear-gradient(135deg, #3a6df0 0%, #6a4cf5 55%, #8a4cf0 100%);
  border: none;
  color: #fff;
  overflow: hidden;
  justify-content: space-between;
}

.holiday-carousel-card::after {
  content: '';
  position: absolute;
  right: -30px;
  bottom: -30px;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.holiday-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  z-index: 1;
}

.holiday-card__title {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  opacity: 0.95;
}

.holiday-card__viewall {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
}

.holiday-card__viewall:hover {
  color: #fff;
  text-decoration: underline;
}

.holiday-slide {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  animation: fadeSlide 0.4s ease;
}

@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateX(8px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.holiday-slide__name {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px;
  line-height: 1.25;
}

.holiday-slide__date {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}

.holiday-slide--empty {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
}

.holiday-card__dots {
  display: flex;
  gap: 6px;
  margin-top: 12px;
  z-index: 1;
}

.holiday-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.2s ease;
}

.holiday-dot.active {
  width: 16px;
  border-radius: 4px;
  background: #fff;
}

.holiday-card__nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  z-index: 2;
  cursor: pointer;
  transition: background 0.2s ease;
}

.holiday-card__nav:hover {
  background: rgba(255, 255, 255, 0.32);
}

.holiday-card__nav--prev {
  left: 10px;
}

.holiday-card__nav--next {
  right: 10px;
}

/* ---- On Leave Today / shared people list ---- */
.hrm-people-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  max-height: 150px;
}

.hrm-people-list__item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.hrm-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: #eef0f5;
}

.hrm-people-list__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.hrm-people-list__name {
  font-size: 12.5px;
  font-weight: 600;
  color: #23253a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hrm-people-list__meta {
  font-size: 11px;
  color: #8a8d99;
}

/* ---- Empty state (used for On Leave + Working Remotely) ---- */
.hrm-empty-state {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #5a5d6b;
  font-size: 13px;
}

.hrm-empty-state__icon {
  font-size: 28px;
  color: #c7c9d1;
  margin-bottom: 8px;
}

.hrm-empty-state__sub {
  font-size: 11.5px;
  color: #9a9ca5;
  margin-top: 2px;
}

/* ---- Working Remotely avatar stack ---- */
.hrm-avatar-stack-wrap {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hrm-avatar-stack {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.hrm-avatar-stack__item {
  position: relative;
  margin-left: -10px;
}

.hrm-avatar-stack__item:first-child {
  margin-left: 0;
}

.hrm-avatar--stacked {
  width: 38px;
  height: 38px;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #eef0f5;
}

.hrm-avatar-stack__badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #23253a;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  border: 2px solid #fff;
}

.hrm-avatar-stack__names {
  font-size: 11.5px;
  color: #5a5d6b;
  line-height: 1.5;
}

@media (max-width: 767px) {
  .hrm-card {
    min-height: 160px;
    padding: 14px;
  }

  .holiday-slide__name {
    font-size: 17px;
  }
}

/* ---- Holidays List Modal ---- */
.holidays-modal-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 360px;
  overflow-y: auto;
}

.holidays-modal-list__item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #eef0f5;
  border-radius: 10px;
  transition: background 0.15s ease;
}

.holidays-modal-list__item:hover {
  background: #f8f9fb;
}

.holidays-modal-list__date-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, #3a6df0 0%, #6a4cf5 100%);
  color: #fff;
  flex-shrink: 0;
}

.holidays-modal-list__day {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.1;
}

.holidays-modal-list__month {
  font-size: 10px;
  text-transform: uppercase;
  opacity: 0.9;
}

.holidays-modal-list__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.holidays-modal-list__name {
  font-size: 13.5px;
  font-weight: 600;
  color: #23253a;
}

.holidays-modal-list__weekday {
  font-size: 11.5px;
  color: #8a8d99;
}

.birthday-card {
  padding: 18px 20px;
}

.birthday-card__header {
  margin-bottom: 14px;
}

.birthday-card__badge {
  display: inline-flex;
  align-items: center;
  font-size: 12.5px;
  font-weight: 600;
  color: #e0576e;
  background: #fdeef0;
  padding: 5px 12px;
  border-radius: 20px;
}

.birthday-section {
  margin-bottom: 16px;
}

.birthday-section:last-child {
  margin-bottom: 0;
}

.birthday-section__title {
  font-size: 12px;
  font-weight: 600;
  color: #8a8d99;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

.birthday-today-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.birthday-today-list__item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.birthday-today-list__name {
  font-size: 13px;
  font-weight: 600;
  color: #23253a;
  flex-grow: 1;
}

.birthday-today-list__wish {
  font-size: 12px;
  font-weight: 600;
  color: #6a4cf5;
  text-decoration: none;
}

.birthday-today-list__wish:hover {
  text-decoration: underline;
}

.birthday-upcoming-list {
  display: flex;
  gap: 18px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.birthday-upcoming-list__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 64px;
  flex-shrink: 0;
}

.hrm-avatar--upcoming {
  width: 44px;
  height: 44px;
  margin-bottom: 6px;
}

.birthday-upcoming-list__name {
  font-size: 11.5px;
  font-weight: 600;
  color: #23253a;
  max-width: 64px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.birthday-upcoming-list__date {
  font-size: 10.5px;
  color: #8a8d99;
}

.hrm-avatar--initials {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.02em;
}

/* ============================================================
   HR UPDATES WIDGET — Keka-style tab strip + collapsible body
   ============================================================ */
.hr-updates-card {
  padding: 0;
  overflow: hidden;
}

.hr-updates-tabs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.hr-updates-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: #8a8d99;
  background: transparent;
  border: none;
  border-radius: 20px;
  padding: 7px 13px;
  cursor: pointer;
  transition: all .15s ease;
}

.hr-updates-tab i {
  font-size: 14px;
}

.hr-updates-tab:hover {
  background: #f8f9fb;
  color: #5a5d6b;
}

.hr-updates-tab.active {
  background: #6a4cf5;
  color: #fff;
}

.hr-updates-collapse-btn {
  margin-left: auto;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid #eef0f5;
  background: #fff;
  color: #8a8d99;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.hr-updates-collapse-btn:hover {
  background: #f8f9fb;
}

.hr-updates-body {
  padding: 18px 20px;
}

.hr-updates-list {
  max-height: 260px;
  overflow-y: auto;
}

.hr-announcement-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.hr-announcement-item {
  padding: 12px 14px;
  border: 1px solid #eef0f5;
  border-radius: 10px;
}

.hr-announcement-item__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.hr-announcement-item__title {
  font-size: 13px;
  font-weight: 700;
  color: #23253a;
}

.hr-announcement-item__content {
  font-size: 12px;
  color: #5a5d6b;
  margin: 0;
  line-height: 1.5;
}

.hr-announcement-item__badge {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 2px 9px;
  border-radius: 20px;
  letter-spacing: .3px;
}

.hr-badge-urgent {
  background: #fdeef0;
  color: #e0576e;
}

.hr-badge-normal {
  background: #eef2ff;
  color: #4f46e5;
}

.hr-badge-info {
  background: #ecfeff;
  color: #0891b2;
}

.hr-updates-viewall {
  display: inline-block;
  margin-top: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #6a4cf5;
  text-decoration: none;
}

.hr-updates-viewall:hover {
  text-decoration: underline;
}

@media (max-width: 767px) {
  .hr-updates-tabs {
    padding: 10px 12px;
  }

  .hr-updates-tab span {
    display: none;
  }

  .hr-updates-tab i {
    font-size: 16px;
  }

  .hr-updates-body {
    padding: 14px 16px;
  }
}
</style>

<style scoped>
/* ============================================================
   DASHBOARD TAB SWITCHER (UI only) — CRM Dashboard / HRMS Dashboard
   ============================================================ */
.dashboard-tabs {
  display: flex;
  gap: 10px;
}

.dashboard-tab {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
  background: #e8eefb;
  border: none;
  border-radius: 999px;
  padding: 9px 24px;
  cursor: pointer;
  transition: all .15s ease;
}

.dashboard-tab:hover {
  color: #111936;
}

.dashboard-tab.active {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.28);
}

.birthday-banner {
  position: fixed;
  top: 90px;
  right: 24px;
  z-index: 1050;
  background: linear-gradient(135deg, #ff6b9d 0%, #6a4cf5 100%);
  color: #fff;
  padding: 14px 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}

.birthday-banner__close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #fff;
  border-radius: 6px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 767px) {
  .dashboard-tabs {
    width: 100%;
  }

  .dashboard-tab {
    flex: 1;
    justify-content: center;
  }
}
</style>